import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "test",
  class: "fixed z-50 inset-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none"
}
const _hoisted_2 = { class: "w-full max-w-sm font-poppins" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6 text-white fill-current",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337\n                  29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667\n                  10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834\n                  17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "px-4 py-2 -mx-3" }
const _hoisted_6 = { class: "mx-3" }
const _hoisted_7 = { class: "text-sm text-start text-gray-600" }

import { NotificationSchema } from '@/types/notiwind';
import { useScriptTag } from '@vueuse/core';
import { getChatGroups, getLiveNotification } from '@/helpers/socialSignOn';
import {
  onMounted,
  onUnmounted,
  watch,
} from 'vue';
import store from '@/store';

interface NotificationClassesType {
  [key: string]: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useScriptTag('https://widget.dojah.io/widget.js');

onMounted(async () => {
  let unsubscribe;
  let unsubscribe2;
  watch(() => store.state.user, async () => {
    unsubscribe = await getChatGroups();
    unsubscribe2 = await getLiveNotification();
  });

  onUnmounted(unsubscribe!);
  onUnmounted(unsubscribe2!);
});

const notificationBgClasses: NotificationClassesType = {
  error: 'bg-red-500',
  success: 'bg-green-500',
  info: 'bg-primary-default',
};

const notificationTextClasses: NotificationClassesType = {
  error: 'text-red-500',
  success: 'text-green-500',
  info: 'text-primary-default',
};

return (_ctx: any,_cache: any) => {
  const _component_Notification = _resolveComponent("Notification")!
  const _component_NotificationGroup = _resolveComponent("NotificationGroup")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NotificationGroup, { group: "foo" }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent('script'), null, {
          default: _withCtx(() => [
            _createTextVNode(" (function (d, w, c) { w.BrevoConversationsID = '620a714c49dba711495b46a9'; w[c] = w[c] || function () { (w[c].q = w[c].q || []).push(arguments); }; var s = d.createElement('script'); s.async = true; s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js'; if (d.head) d.head.appendChild(s); })(document, window, 'BrevoConversations'); ")
          ]),
          _: 1
        })),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Notification, {
              enter: "transform ease-out duration-300 transition",
              position: "bottom",
              "enter-from": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4",
              "enter-to": "translate-y-0 opacity-100 sm:translate-x-0",
              leave: "transition ease-in duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0",
              move: "transition duration-500",
              "move-delay": "delay-300"
            }, {
              default: _withCtx(({ notifications }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((notifications as NotificationSchema[]), (notification) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md",
                    key: notification.id
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex items-center justify-center w-12", notificationBgClasses[notification.type]])
                    }, _hoisted_4, 2),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["font-semibold", notificationTextClasses[notification.type]])
                        }, _toDisplayString(notification.title), 3),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(notification.text), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ], 64))
}
}

})